export default "__VITE_ASSET__BocdN9oG__"